import React from "react";
import { Navigate } from "react-router-dom";

// The inbox now lives under My Tasks; keep old /inbox links working.
export default function InboxPage() {
  return <Navigate to="/tasks?view=inbox" replace />;
}
